import React from 'react';
import theme from '../style/theme';

interface IconProps {
  fillColor?: string;
}

const PlusIcon: React.FC<IconProps> = ({
  fillColor = `${theme.colors.g3}`,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Union">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 18.5C9 19.0523 9.44771 19.5 10 19.5C10.5523 19.5 11 19.0523 11 18.5V11H18.5C19.0523 11 19.5 10.5523 19.5 10C19.5 9.44771 19.0523 9 18.5 9H11V1.5C11 0.947716 10.5523 0.5 10 0.5C9.44771 0.5 9 0.947716 9 1.5V9H1.5C0.947715 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11H9V18.5Z"
          fill="#D9D9D9"
        />
        <path
          d="M11 11V10.75H10.75V11H11ZM11 9H10.75V9.25H11V9ZM9 9V9.25H9.25V9H9ZM9 11H9.25V10.75H9V11ZM10 19.25C9.58579 19.25 9.25 18.9142 9.25 18.5H8.75C8.75 19.1904 9.30964 19.75 10 19.75V19.25ZM10.75 18.5C10.75 18.9142 10.4142 19.25 10 19.25V19.75C10.6904 19.75 11.25 19.1904 11.25 18.5H10.75ZM10.75 11V18.5H11.25V11H10.75ZM18.5 10.75H11V11.25H18.5V10.75ZM19.25 10C19.25 10.4142 18.9142 10.75 18.5 10.75V11.25C19.1904 11.25 19.75 10.6904 19.75 10H19.25ZM18.5 9.25C18.9142 9.25 19.25 9.58579 19.25 10H19.75C19.75 9.30964 19.1904 8.75 18.5 8.75V9.25ZM11 9.25H18.5V8.75H11V9.25ZM10.75 1.5V9H11.25V1.5H10.75ZM10 0.75C10.4142 0.75 10.75 1.08579 10.75 1.5H11.25C11.25 0.809645 10.6904 0.25 10 0.25V0.75ZM9.25 1.5C9.25 1.08579 9.58579 0.75 10 0.75V0.25C9.30964 0.25 8.75 0.809645 8.75 1.5H9.25ZM9.25 9V1.5H8.75V9H9.25ZM1.5 9.25H9V8.75H1.5V9.25ZM0.75 10C0.75 9.58579 1.08579 9.25 1.5 9.25V8.75C0.809644 8.75 0.25 9.30964 0.25 10H0.75ZM1.5 10.75C1.08579 10.75 0.75 10.4142 0.75 10H0.25C0.25 10.6904 0.809644 11.25 1.5 11.25V10.75ZM9 10.75H1.5V11.25H9V10.75ZM9.25 18.5V11H8.75V18.5H9.25Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
